import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL, umsUrl } from '../../../../Containers/Config/index.js';
import { CLIENT_RESET_PASSWORD_V2, CLIENT_RESET_PASSWORD_V2_SUCCESS, CLIENT_RESET_PASSWORD_V2_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* clientResetPasswordV2({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v2/client/reset-password`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        'Project-Code': 'ADMIN_ACCESS',
        'X-Requested-By': 'one-admin',
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: CLIENT_RESET_PASSWORD_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CLIENT_RESET_PASSWORD_V2_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: CLIENT_RESET_PASSWORD_V2_ERROR, payload: error });
  }
}

export function* watchClientResetPasswordV2() {
  yield takeEvery(CLIENT_RESET_PASSWORD_V2, clientResetPasswordV2);
}

function* clientResetPasswordV2Saga() {
  yield all([fork(watchClientResetPasswordV2)]);
}

export default clientResetPasswordV2Saga;
